import { budgetBuilder as constants } from "store/constants";
import {
	fetchableInitialState,
	reduceIsFetching,
	reduceSetError,
} from "store/factories/fetchable";


const initialState = {
	...fetchableInitialState,
	content: {
		budgetBuilder: {
			reviewEvents: [],
			adminTeamMembers: [],
			userAccesses: [],
		},
		isModified: false,
		lineItems: {
			sponsoredCosts: [],
			internalCostShare: [],
			externalCostShare: [],
		},
		payload: {},
		researchTeam: {
			unnamed: [],
			members: [],
			original: [],
		},
		cachedPeopleById: {},
		currentPeriod: {},
		currentVersion: null,
	},
};

export function budgetBuilder (state = initialState, action) {
	switch (action.type) {
		case constants.BUDGET_IS_FETCHING:
      return reduceIsFetching(state, action);
		case constants.BUDGET_SET_ERROR:
			return reduceSetError(state, action);
		case constants.BUDGET_SET_DATA:
			return {
				...state,
				content: {
					...state.content,
          ...action.payload,
				},
			};
		case constants.SET_CURRENT_VERSION:
			return {
				...state,
				content: {
					...state.content,
					currentVersion: action.payload,
				},
			};
		case constants.UPDATE_PERIOD:
			return {
				...state,
				content: {
					...state.content,
					currentPeriod: {
						...state.content.currentPeriod,
						...action.payload,
					},
				},
			};
		case constants.UPDATE_LINE_ITEMS:
			return {
				...state,
				content: {
					...state.content,
					lineItems: {
						...state.content.lineItems,
						...action.payload,
					}
				}
			};
		case constants.UPDATE_RESEARCH_TEAM:
			return {
				...state,
				content: {
					...state.content,
					researchTeam: {
						...state.content.researchTeam,
						...action.payload,
					}
				}
			};
		case constants.RESET:
			return initialState;
		default:
			return state;
	}
}
